import "./App.css";
import React, { useEffect }from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import HeaderElement from "./components/HeaderElement";
import FooterElement from "./components/FooterElement";
import LayoutHomePage from "./LayoutHomePage";
import LayoutAllPages from "./LayoutAllPages";
import { useCloseResponsiveDetailsOnSmallScreen } from "./components/useCloseResponsiveDetailsOnSmallScreen";

function PageTitle() {
  const location = useLocation();

  useEffect(() => {
    // Define title mappings for different routes
    const routeTitles = {
      '/': 'Morrisville Borough, PA | Official Website Home Page',
      '/administration': 'Administration | Morrisville Borough, PA',
      '/calendar': 'Calendar | Morrisville Borough, PA',
      '/citizenreporter': 'Citizen Reporter | Morrisville Borough, PA',
      '/civilservice': 'Civil Service Commission | Morrisville Borough, PA',
      '/code': 'Code Enforcement | Morrisville Borough, PA',
      '/contact': 'Contact | Morrisville Borough, PA',
      '/council': 'Borough Council | Morrisville Borough, PA',
      '/docs/': 'Document Archive | Morrisville Borough, PA',
      '/eac': 'E A C | Morrisville Borough, PA',
      '/employment': 'Employment | Morrisville Borough, PA',
      '/forms': 'Forms | Morrisville Borough, PA',
      '/howdoi': 'How Do I? | Morrisville Borough, PA',
      '/jsbbc': 'J S B B C | Morrisville Borough, PA',
      '/libraryboard': 'Library Board | Morrisville Borough, PA',
      '/mayor': 'Mayor of Morrisville Borough | Morrisville Borough, PA',
      '/medc': 'M E D C | Morrisville Borough, PA',
      '/mma': 'M M A | Morrisville Borough, PA',
      '/planning': 'Planning Commission | Morrisville Borough, PA',
      '/police': 'Police: General | Morrisville Borough, PA',
      '/police/documents': 'Police: Documents | Morrisville Borough, PA',
      '/police/personnel': 'Police: Personnel | Morrisville Borough, PA',
      '/police/resources': 'Police: Resources | Morrisville Borough, PA',
      '/police/statistics': 'Police: Statistics | Morrisville Borough, PA',
      '/police/jobs': 'Police: Job Openings |Morrisville Borough, PA',
      '/privacy': 'Privacy Statement | Morrisville Borough, PA',
      '/publicworks': 'Public Works | Morrisville Borough, PA',
      '/resources': 'Local Area Resources | Morrisville Borough, PA',
      '/rental': 'Residential Rental License Permit Program | Morrisville Borough, PA',
      '/rtk': 'Right To Know | Morrisville Borough, PA',
      '/sanitation': 'Sanitation | Morrisville Borough, PA',
      '/search': 'Search | Morrisville Borough, PA',
      '/stormwater': 'Stormwater Management | Morrisville Borough, PA',
      '/tax': 'Tax Collector | Morrisville Borough, PA',
      '/tourism': 'Tourism | Morrisville Borough, PA',
      '/vprb': 'V P R B | Morrisville Borough, PA',
      '/water-sewer': 'Water & Sewer | Morrisville Borough, PA',
      '/zoning': 'Zoning Hearing Board | Morrisville Borough, PA',
      // Add more routes and their titles as needed
    };

    // Get the title for the current route, default to 'Default Title' if not found
    const title = routeTitles[location.pathname] || '404 Page Not Found';

    // Set the document title
    document.title = title;
  }, [location]); // Update title when location changes

  return null; // This component doesn't render anything
}


function App() {

  useCloseResponsiveDetailsOnSmallScreen(1200, true);

  return (
    <div>
      <PageTitle />
      <HeaderElement />

      <Routes>
        <Route path="/" exact element={<LayoutHomePage />} />
        <Route path="/*" element={<LayoutAllPages />} />
      </Routes>
      
      <FooterElement />
    </div>
  );
  
}

export default App;
